module.exports = __webpack_public_path__ + "static/media/asymmetric-stripline.b53eba38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/StackupDesign/Viewer/ResultViewer/SimulationModelImg/asymmetric-stripline.svg
// module id = 1244
// module chunks = 0